export default () => ({
  trigger: {
    name: 'insurance_selector.show_all_insurance_options',
    params: {},
  },
  config: {
    event: {
      name: 'select_more',
      params: {
        sub_feature: null,
        content: 'all_insurances',
      },
    },
    nonInt: true,
  },
});
